// AI Generated Test
import { Component, Input, Output, EventEmitter } from '@angular/core';
import Papa from 'papaparse';

// declare let Papa: any;
@Component({
    selector: 'form-rule-import-upload',
    templateUrl: './form-rule-import-upload.component.html',
    standalone: false,
})
export class FormRuleImportUploadComponent {
    @Input() step: any;
    @Input() data: any;
    @Output() stepChange = new EventEmitter<any>();
    @Output() dataChange = new EventEmitter<any>();

    openFileDialog (): void {
        const el = document.getElementById('new_bulk_csv') as HTMLInputElement;
        el.click();
    }

    newBulkFile (event: any): void {
        const file = event.target.files[0];
        if (file) {
            Papa.parse(file, {
                complete: (result: any) => {
                    this.data = result;
                    this.dataChange.emit(this.data);
                    this.step = 2;
                    this.stepChange.emit(this.step);
                },
            });
        }
    }
}
